import { initialValidations } from "_common/ssrWrapper";
import Page                   from "_components/pages/diamondPayout/manageDonation";
import { getDiamondDetails }  from "_services/api/payout";

function component ( { details } ) {
	return (
		<Page details = { details } />
	);
}

export default component;

const getServerSideProps = context => initialValidations ( context, async defaultProps => {
	const results = await Promise.allSettled (
		[
			getDiamondDetails.bind ( defaultProps ) ()
		]
	);

	let details = {};
	// let forceLogout = false;

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					details = result.value;
					break;
			}
		}

		/* if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
        forceLogout = true; */
	} );

	/* if ( forceLogout )
    return {
      redirect: {
        destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
        permanent   : false
      }
    }; */

	return {
		props: {
			...defaultProps,
			details,
			noAuth      : defaultProps?.isWebview ? true : false,
			noLayout    : true,
			noAnalytics : true
		}
	};

} );

export { getServerSideProps };
